import "../../global.css";
import "./discountList.css";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useState } from "react";
import { userRequest } from "../../requestMethods";
import IconButton from "@mui/material/IconButton";
import { formatTimeDDMMYYY } from "../../util/helper";
import { DeleteOutline } from "@mui/icons-material";
import { useCompany } from "../../components/context/CompanyContext";
import Swal from "sweetalert2";
import Loading from "../../components/loading/loading";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Switch from "@mui/material/Switch";
import { useDispatch, useSelector } from "react-redux";
import { titleSetRef } from "../../redux/titleRedux";
import CustomGrid from "../../components/grid/CustomGrid";
export default function DiscountList() {
  const [discounts, setDiscounts] = useState([{}]);
  const { companyId } = useCompany();
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isLoading, setIsLoading] = useState(false);
  const [uniqueDiscount, setUniqueDiscount] = useState(false);
  const [inputs, setInputs] = useState({});
  const [date, setDate] = useState();
  const [dateNow, setDateNow] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(titleSetRef({ title: "Cupom" }));
    if (companyId > 0) {
      setDate(dayjs(new Date()).add(+1, "day").format("YYYY-MM-DD"));
      setDateNow(dayjs(new Date()).format("YYYY-MM-DD"));
      getDiscounts();
    }
  }, [companyId]);

  const getDiscounts = async () => {
    try {
      const res = await userRequest.get(`${companyId}/discounts`);
      setDiscounts(res.data);
    } catch {
      console.log();
    }
  };
  const addDiscount = async () => {
    let valida = false;
    if (inputs.codeDiscount !== "" && inputs.codeDiscount !== undefined) {
      valida = true;
    } else {
      Swal.fire(
        "Atenção!",
        "O campo Cupom deve ser preenchido.",
        "warning"
      );
    }

    if (valida) {
      if (date >= dateNow) {
        let disc = discounts.find(
          (item) =>
            item.codeDiscount === inputs.codeDiscount.toString().toUpperCase()
        );
        if (!disc) {
          const res = await userRequest.post(`${companyId}/discounts`, {
            codeDiscount: inputs.codeDiscount.toUpperCase(),
            expiryDate: date,
            createdBy: currentUser.userId,
            companyId: companyId,
            discount: inputs.discount !== undefined && inputs.discount !== "" ? inputs.discount : 0,
            uniqueDiscount: uniqueDiscount,
          });
          if (Object.keys(res.data).length > 0) {
            Swal.fire("Parabéns!", "Cupom criada com sucesso!", "success");
            getDiscounts();
          }
        } else {
          Swal.fire("Atenção!", "Cupom de desconto existente!", "warning");
        }
      } else {
        Swal.fire("Atenção!", "O campo Cupom deve ser preenchido.", "warning");
      }
    }
  };
  const deleteDiscount = async (cp) => {
    const res = await userRequest.put(`${companyId}/discounts/${cp}`, {
      deleted: dateNow,
      lastUserUpdate: currentUser.userId,
    });

    if (res.data > 0) {
      getDiscounts();
    } else {
      Swal.fire("Atenção!", "Erro ao excluir desconto!", "error");
    }
  };
  const onButtonDeleteClick = async (e, row) => {
    if (currentUser.isAdmin) {
      Swal.fire({
        title: "Tem certeza que deseja excluir?",
        text: "Você não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#EE8253",
        confirmButtonText: "Sim, excluir!",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          deleteDiscount(row);
        }
      });
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para excluir o desconto!",
        "warning"
      );
    }
  };
  const handleChange = (e) => {
    setInputs((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  const columns = [
    {
      field: "codeDiscount",
      type: "text",
      align: "left",
      headerName: "Cupom",
      width: 100,
    },
    {
      field: "discount",
      type: "number",
      align: "center",
      headerAlign: "center",
      headerName: "% Desconto",
      width: 150,
    },
    {
      field: "expiryDate",
      headerName: "Data expiração",
      width: 200,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy",
      type: "date",
    },
    {
      field: "createdBy",
      type: "text",
      headerName: "Criado por",
      width: 150,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "uniqueDiscount",
      type: "boolean",
      headerName: "Usar 1 vez",
      width: 150,
      align: "center",
      headerAlign: "center",
      display: "flex",
      renderCell: (params) => {
        // eslint-disable-next-line default-case
        if (params.value) {
          return "SIM";
        } else {
          return "NÃO";
        }
      },
    },
    {
      field: "createdAt",
      headerName: "Criada em",
      width: 150,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy",
      type: "date",
    },
    {
      field: "deleted",
      headerName: "Inativado",
      width: 150,
      align: "center",
      headerAlign: "center",
      type: "date",
      format: "dd/MM/yyyy",
    },
    {
      field: "deletar",
      type: "text",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      display: "flex",
      renderCell: (params) => {
        if (!params.row.deleted) {
          return (
            <IconButton
              onClick={(e) => onButtonDeleteClick(e, params.row.discountId)}
            >
              <DeleteOutline />
            </IconButton>
          );
        }
      },
    },
  ];
  const handleChangeStart = (e) => {
    setDate(e.target.value);
  };
  const handleChangeUniqueDiscount = (e) => {
    //setAdmin(e.target.value);
    setUniqueDiscount(e.target.checked);
  };
  return (
    <div className="cust-page">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="cust-title">Cupons de Desconto</div>

          {/* Novo cupom */}
          <div className="cust-card">
            <div className="cust-section-header">Novo Cupom</div>
            <div className="cust-fields cust-fields-3" style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
              <div className="cust-field">
                <label className="cust-label">Cupom</label>
                <input
                  className="cust-input"
                  type="text"
                  name="codeDiscount"
                  onChange={handleChange}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">% Desconto</label>
                <input
                  className="cust-input"
                  type="number"
                  name="discount"
                  onChange={handleChange}
                  maxLength="100"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Data de Expiração</label>
                <input
                  className="cust-input"
                  type="date"
                  id="expiryDate"
                  value={date}
                  name="trip-start"
                  min={dateNow}
                  onChange={handleChangeStart}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Utilizar apenas 1 vez?</label>
                <div className="cust-switch-row" style={{ padding: "4px 0 0 0" }}>
                  <Switch
                    defaultChecked={false}
                    onChange={(e) => handleChangeUniqueDiscount(e)}
                  />
                </div>
              </div>
            </div>
            <div style={{ padding: "0 16px 16px" }}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<SaveIcon />}
                onClick={addDiscount}
              >
                Adicionar Cupom
              </Button>
            </div>
          </div>

          {/* Lista */}
          <div className="cust-card">
            <div className="cust-section-header">Cupons Cadastrados</div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                gridId="discountList"
                rows={discounts}
                columns={columns}
                pageSize={45}
                checkboxSelection={false}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
